<!-- DESKTOP SIDEBAR -->
@if (!isResponsiveMode) {
<div
  class="sidebar-container"
  [ngClass]="{ collapsed: !isSidebarOpen, expanded: isSidebarOpen }"
>
  <!-- Logo (fixed, outside scroll). Full positive wordmark when expanded,
       positive imagotipo (symbol only) when collapsed. -->
  <div class="sidebar-title">
    <div class="sidebar-logo">
      @if (isSidebarOpen) {
        <img class="logo-full"
             src="assets/layout/images/branding/gs-studium-2026.png" alt="Grupo Studium" />
      } @else {
        <img class="logo-mark"
             src="assets/layout/images/branding/gs-imagotipo-2026.png" alt="Grupo Studium" />
      }
    </div>
  </div>

  <!-- Scrollable menu: flat links grouped under uppercase section labels -->
  <nav class="menu-items-scrollable menu-sections">
    @for (section of menuSections; track section.id; let first = $first) {
      <div class="menu-section">
        @if (isSidebarOpen) {
          <div class="menu-section__label">{{ section.labelKey | transloco }}</div>
        } @else if (!first) {
          <div class="menu-section__divider"></div>
        }
        <ul class="menu-section__list">
          @for (item of section.items; track item.id) {
            <li>
              <a
                class="menu-link"
                [class.is-active]="isItemActive(item)"
                [routerLink]="item.routerLink"
                [title]="!isSidebarOpen ? (item.labelKey ? (item.labelKey | transloco) : (item.label ?? '')) : ''"
                (click)="handleMenuItemClick(item)"
              >
                <lucide-icon class="menu-link__icon" [name]="item.icon" [size]="17" />
                @if (isSidebarOpen) {
                  <span class="menu-link__label">{{ item.labelKey ? (item.labelKey | transloco) : item.label }}</span>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </nav>

  <!-- Footer: collapse toggle (the user lives in the header) -->
  <div class="sidebar-footer">
    <ul class="buttons-container-down">
      @for (item of modelLower; track item; let i = $index) {
      <li class="item-sidebar">
        <app-item-menu
          [item]="item"
          [index]="i"
          [root]="true"
          [isSidebarOpen]="isSidebarOpen"
        >
        </app-item-menu>
      </li>
      }
    </ul>
  </div>
</div>
}

<!-- RESPONSIVE SIDEBAR (MOBILE) -->
@if (isResponsiveMode) {
<!-- Overlay backdrop - only shown when open -->
@if (isSidebarOpen) {
<div class="sidebar-overlay" (click)="closeSidebar()"></div>
}

<!-- Sidebar container - only shown when open -->
@if (isSidebarOpen) {
<div class="sidebar-responsive-container" [class.open]="isSidebarOpen">
  <!-- Close button -->
  <button type="button" class="close-button" (click)="closeSidebar()">
    <lucide-icon name="X" size="32"></lucide-icon>
  </button>

  <!-- User Profile Section -->
  <div class="profile-section">
    <div class="profile-left">
      <div class="profile-avatar">
        @if (currentEmployeeId) {
        <app-avatar
          [employeeId]="currentEmployeeId"
          [name]="userName"
          [size]="72"
          [showInfo]="false"
        >
        </app-avatar>
        } @else {
        <img [src]="getUserAvatar()" [alt]="userName" />
        }
      </div>
      <div class="profile-info">
        <div class="profile-name">{{ userName }}</div>
        <button type="button" class="profile-link" (click)="navigateToProfile()">
          {{ userRole }}
        </button>
      </div>
    </div>
    <button type="button"
      class="settings-icon-button"
      [class.close-mode]="isProfileMenuOpen"
      (click)="toggleProfileMenu()"
    >
      <lucide-icon
        [name]="isProfileMenuOpen ? 'X' : 'Settings'"
        class="settings-icon"
      ></lucide-icon>
    </button>
  </div>

  <!-- Profile Menu Card -->
  @if (isProfileMenuOpen) {
  <div class="profile-menu-card">
    <ul class="profile-menu-list">
      @for (item of profileMenuItems; track item.id; let i = $index) {
      <li class="profile-menu-item">
        <app-item-menu
          [item]="item"
          [index]="i"
          [root]="true"
          [isSidebarOpen]="true"
          [isActive]="false"
          (itemClick)="handleProfileMenuItemClick($event)"
        >
        </app-item-menu>
      </li>
      }
    </ul>
  </div>
  }

  <!-- Scrollable Content -->
  <div class="scrollable-content">
    <!-- Navigation Menu -->
    <ul class="navigation-menu">
      @for (item of modelNavigation; track item.id; let i = $index) { @if
      (!item.separator) {
      <li class="menu-item">
        <app-item-menu
          [item]="item"
          [index]="i"
          [root]="true"
          [isSidebarOpen]="true"
          [isActive]="isActive(item.id)"
          (itemClick)="handleMenuItemClick($event)"
          (submenuExpanded)="scrollToItem($event)"
        >
        </app-item-menu>
      </li>
      } }
    </ul>

    <!-- Bottom Actions (Logout only) -->
    <div class="bottom-actions-container">
      <app-button
        variant="icon-ghost"
        icon="LogOut"
        size="small"
        (onClick)="handleLogout()"
        class="logout-button-responsive"
      >
      </app-button>
    </div>
  </div>
</div>
} }
